import { TWithdrawalMethodDetail } from '../apis/queries/use-get-withdrawal-method-query'

import { TPayoutInfoDetails } from '@/app/(main)/rewards/select-withdraw-method/page'

type TParseWithdrawOption = {
  readonly payoutOptions: TWithdrawalMethodDetail[]
  readonly selectedOption: string
  readonly phoneNumber: string
}

export default function parseWithdrawOption({
  payoutOptions,
  selectedOption,
}: TParseWithdrawOption): Promise<TPayoutInfoDetails> {
  return new Promise((resolve, reject) => {
    const findBank = payoutOptions.find((res) => res?.id === selectedOption)
    if (findBank) {
      resolve({
        id: findBank.id,
        type: findBank.type,
        provider: findBank.provider,
        accountNumber: findBank.accountNumber,
        accountName: findBank.provider,
        isFree: findBank.isFree,
        minimalWithdrawAmount: findBank.minimalWithdrawAmount,
        isSpecial: findBank.isSpecial,
        adminFee: findBank.adminFee,
        enable: findBank.enable,
      })
    } else {
      reject(new Error('Selected payout option not found.'))
    }
  })
}
